<script setup lang="ts">
import { useSlots } from 'vue'

const props = defineProps<{
	underline?: boolean
}>()
const slots = useSlots()
</script>

<template>
	<tr :class="{ underline: props.underline }">
		<td v-if="slots.col0" class="text-muted px-1 small">
			<slot name="col0"></slot>
		</td>
		<td v-if="slots.col1" class="text-muted px-1 small">
			<slot name="col1"></slot>
		</td>
		<td v-if="slots.col2" class="text-muted px-1 small">
			<slot name="col2"></slot>
		</td>
		<td v-if="slots.col3" class="text-muted px-1 small">
			<slot name="col3"></slot>
		</td>
		<td class="text-end text-muted px-1 small" v-if="slots.col_end">
			<slot name="col_end"></slot>
		</td>
	</tr>
</template>

<style lang="sass" scoped>
:deep(.red)
  color: #ff5402
  font-weight: bold

:deep(.orange)
  color: #ff9300
  font-weight: bold

:deep(.green)
  color: #62d837
  font-weight: bold
</style>
